import { slideDown, slideUp } from '../modules/domSlider';
import { xhrLoad } from '../functions/xhrLoad';
import {
  OPTION_ATTR,
  LIST_CLASS,
  getWrapper,
  getSelect,
  itemClick,
  OPEN_CLASS
} from './select';
import { querySelectorAll, querySelector } from './querySelectors';
import tooltip from '../scripts/tooltip';
import formatPrice from './formatPrice';
import getCurrency from './getCurrency';
import { setListenersFromSelector } from './listeners';
import { setExpressTexts } from '../scripts/productDetail'; // eslint-disable-line

const WRAPPER_CLASS = 'w-diamond-selector';
const ETHIC_SELECTED_CLASS = 'w-diamond-selector--ethic-selected';
const GROPUPS_CLASS = 'w-diamond-selector__groups';
const GROUP_ELEMET = 'optgroup';
const GROUP_CLASS = 'w-diamond-selector__group';
const GROUP_ACTIVE_CLASS = 'w-diamond-selector__group--active';
const GROUP_HEADER_CLASS = 'w-diamond-selector__group-header';
const LIST_WRAPPER_CLASS = 'w-diamond-selector__list-wrap';
const D_LIST_CLASS = 'w-diamond-selector__list';
const ITEM_CLASS = 'w-diamond-selector__item';
const ITEM_ACTIVE_CLASS = 'w-diamond-selector__item--active';
const INNER_CLASS = 'w-diamond-selector__inner';
const IMAGE_ATTR = 'data-image';
const SELECTED_TEXT_ATTR = 'data-selected-text';
const SUMMARY_CLASS = 'w-diamond-summary';
const DETAILED_CLASS = 'js-diamond-detail';
const CHOOSE_CLASS = 'js-diamond-choose';
const CHOOSE_INIT_CLASS = 'jdc-init';
const COUNT_ATTR = 'data-count';
const ETHIC_ATTR = 'data-ethic-diamond';

let selectedText = null;
let diamondPrices = window.diamonds_prices;

let getSelectedText = function(wrapper) {
  if (selectedText) {
    return selectedText;
  }

  let select = getSelect(wrapper);
  selectedText = select.getAttribute(SELECTED_TEXT_ATTR);
  return selectedText;
};

let selectChange = function(event) {
  change(this);
};

let selectFilled = function(event) {
  change(this);
};

let chooseClick = function(event) {
  event.preventDefault();
  let wrapper = getWrapper(this);
  wrapper.classList.remove(OPEN_CLASS);
};

let groupClick = function(event) {
  let wrapper = getWrapper(this);
  let group = this.closest(`.${GROUP_CLASS}`);
  let listWrapper = querySelector(`.${LIST_WRAPPER_CLASS}`, group);
  let oldActiveGroup = querySelector(`.${GROUP_ACTIVE_CLASS}`, wrapper);
  let oldListWrapper = querySelector(`.${LIST_WRAPPER_CLASS}`, oldActiveGroup);

  if (group.classList.contains(GROUP_ACTIVE_CLASS)) {
    slideUp({
      element: listWrapper
    }).then(function() {
      group.classList.remove(GROUP_ACTIVE_CLASS);
    });
  }
  else {
    slideDown({
      element: listWrapper
    });
    group.classList.add(GROUP_ACTIVE_CLASS);

    if (oldActiveGroup) {
      slideUp({
        element: oldListWrapper
      }).then(function() {
        oldActiveGroup.classList.remove(GROUP_ACTIVE_CLASS);
      });
    }
  }
};

let makeItem = function(item) {
  let li = document.createElement('li');
  li.classList.add(ITEM_CLASS);
  li.setAttribute(OPTION_ATTR, item.getAttribute('value'));
  li.addEventListener('click', itemClick);

  if (typeof item.getAttribute(COUNT_ATTR) === 'string') {
    li.setAttribute(COUNT_ATTR, item.getAttribute(COUNT_ATTR));
  }

  li.innerHTML = `
    <div class="${INNER_CLASS}">
      <img src="//eppi.cz/${item.getAttribute(IMAGE_ATTR)}" alt="${item.textContent}" class="u-img">
      ${item.textContent}
      <small></small>
    </div>
  `;

  return li;
};

let makeItems = function(group) {
  let items = querySelectorAll('option', group);
  let list = document.createElement('ul');
  let wrapper = document.createElement('div');
  list.classList.add(D_LIST_CLASS);
  wrapper.classList.add(LIST_WRAPPER_CLASS);

  items.forEach((item) => {
    list.appendChild(makeItem(item));
  });

  wrapper.appendChild(list);

  return wrapper;
};

let makeGroup = function(group) {
  let item = document.createElement('li');
  let groupElement = document.createElement('div');
  item.classList.add(GROUP_CLASS);
  groupElement.classList.add(GROUP_HEADER_CLASS);

  groupElement.innerHTML = `
    <img src="//eppi.cz/${group.getAttribute(IMAGE_ATTR)}" alt="${group.getAttribute('label')}">
    ${group.getAttribute('label')}
  `;

  groupElement.addEventListener('click', groupClick);

  item.appendChild(groupElement);
  item.appendChild(makeItems(group));

  return item;
};

let makeCategories = function(select) {
  let groups = querySelectorAll(GROUP_ELEMET, select);
  let list = document.createElement('ul');
  list.classList.add(GROPUPS_CLASS);

  groups.forEach((group) => {
    list.appendChild(makeGroup(group));
  });

  return list;
};

let change = function(element) {
  let wrapper = getWrapper(element);
  let select = getSelect(wrapper);
  let selectedOption = select.options[select.options.selectedIndex];
  let selectedValue = parseInt(selectedOption.value, 10);
  let newActiveItem = querySelector(`.${ITEM_CLASS}[${OPTION_ATTR}="${selectedValue}"]`, wrapper);
  let newActiveGroup = newActiveItem.closest(`.${GROUP_CLASS}`);
  let oldActive = querySelector(`.${ITEM_ACTIVE_CLASS}`, wrapper);
  let oldActiveGroup = querySelector(`.${GROUP_ACTIVE_CLASS}`, wrapper);
  let isEthic = typeof selectedOption.getAttribute(ETHIC_ATTR) === 'string';
  //let isInStock = parseInt(selectedOption.getAttribute(COUNT_ATTR), 10);

  if (oldActive) {
    oldActive.classList.remove(ITEM_ACTIVE_CLASS);
  }

  if (oldActiveGroup) {
    oldActiveGroup.classList.remove(GROUP_ACTIVE_CLASS);
  }

  if (isEthic) {
    wrapper.classList.add(ETHIC_SELECTED_CLASS);
  }
  else {
    wrapper.classList.remove(ETHIC_SELECTED_CLASS);
  }

  newActiveItem.classList.add(ITEM_ACTIVE_CLASS);
  newActiveGroup.classList.add(GROUP_ACTIVE_CLASS);

  setExpressTexts();
  setPrices(select, selectedValue);
  fillDetailedInfo(select);
};

let setPrices = function(select, selectedValue) {
  let items = querySelectorAll(`.${ITEM_CLASS}`);
  let selectedItemPrice = diamondPrices[selectedValue];
  let currency = getCurrency();

  items.forEach((item) => {
    let priceElement = querySelector('small', item);
    let diff;
    let diamondId = parseInt(item.getAttribute(OPTION_ATTR), 10);

    if (diamondId === selectedValue) {
      priceElement.textContent = getSelectedText();
    }
    else {
      diff = diamondPrices[diamondId] - selectedItemPrice;

      if (!diff) {
        priceElement.innerHTML = '&nbsp;';
      }
      else {
        priceElement.textContent = `${formatPrice(diff, true)} ${currency}`;
      }
    }
  });
};

let fillDetailedInfo = function(select) {
  let dest = querySelector(`.${DETAILED_CLASS}`);
  dest.style.opacity = 0;

  xhrLoad(
    window.location.pathname,
    function(response) {
      dest.innerHTML = response;
      dest.style.opacity = 1;
      tooltip();
    },
    null,
    'post',
    {
      diamond_id: select.value
    }
  );
};

let make = function(select) {
  let wrapper = document.createElement('div');
  wrapper.classList.add(WRAPPER_CLASS);
  wrapper.classList.add(LIST_CLASS);

  wrapper.appendChild(makeCategories(select));
  wrapper.appendChild(querySelector(`.${SUMMARY_CLASS}`));

  select.addEventListener('selectFilled', selectFilled);
  select.addEventListener('change', selectChange);

  setListenersFromSelector(
    `.${CHOOSE_CLASS}`,
    CHOOSE_INIT_CLASS,
    chooseClick,
    true,
    'click',
    wrapper
  );

  return wrapper;
};

export default {
  make: make,
  change: change
};
